import React, { createContext, useContext } from "react";
import { useAuth } from "./AuthContext";
import useWebRTC from "../hooks/useWebRTC";

const CallContext = createContext(null);

export const useCall = () => {
  const context = useContext(CallContext);
  if (!context) {
    throw new Error("useCall must be used within a CallProvider");
  }
  return context;
};

export const CallProvider = ({ children }) => {
  const { user } = useAuth();
  const webRTC = useWebRTC(user);

  return <CallContext.Provider value={webRTC}>{children}</CallContext.Provider>;
};
